import { genId } from '@/components/canvas/store/helpers';
import type { TimerBlock } from '@/components/canvas/blocks/types';
import { DEFAULT_TIMER_DURATION, DEFAULT_TIMER_MODE } from '@/components/Timer';

const DEFAULT_SIZE = 220;

export function createTimerBlock(config: {
  id?: string;
  x: number;
  y: number;
  width?: number;
  height?: number;
  zIndex?: number;
  name?: string;
}): TimerBlock {
  const size = config.width ?? config.height ?? DEFAULT_SIZE;
  return {
    id: config.id ?? genId('timer'),
    type: 'timer',
    name: config.name ?? '定时器',
    layout: {
      x: config.x,
      y: config.y,
      width: config.width ?? size,
      height: config.height ?? size,
      zIndex: config.zIndex ?? 1,
    },
    data: {
      defaultTarget: { ...DEFAULT_TIMER_DURATION },
      mode: DEFAULT_TIMER_MODE,
      size: DEFAULT_SIZE,
    },
  };
}
